import React, { useState } from "react";
import { View, TouchableOpacity } from "react-native";
import { Popable } from "react-native-popable";
import { AppText, AppIcon } from "@toothfairy/shared-ui";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import WorkspaceChip from "../../Workspaces/Components/WorkspaceChip";
import useWorkspaces from "../../../Hooks/useWorkspaces";
// ners is an array of objects with the following structure:
// {
//   "type": "string",
//   "value": "string"
// }
const NerViewComponent = ({
  chunk_id,
  ners = [],
  maxNerByChunk = 10,
  showHover = true,
}) => {
  const { currentTheme } = AppTheme.useTheme();
  const { getWorkspaceEntities } = useWorkspaces();
  const [isExpanded, setIsExpanded] = useState(false);

  const mapNERWithIcon = (ner) => {
    return `${
      getWorkspaceEntities("ner")?.find(
        (e) => e?.label?.toLowerCase() === ner?.toLowerCase()
      )?.emoji || "📋"
    } ${ner} -`;
  };

  const displayedNers = isExpanded ? ners : ners?.slice(0, maxNerByChunk);
  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        marginTop: 5,
        flexWrap: "wrap",
      }}
    >
      {ners &&
        ners?.length > 0 &&
        displayedNers.map((ner, i) => {
          return (
            <Popable
              visible={showHover}
              numberOfLines={2}
              backgroundColor={currentTheme?.theme?.tooltipBackgroundColor}
              key={`${chunk_id}_pop_${i}`}
              style={[
                {
                  top: 30,
                  zIndex: 20,
                  maxWidth: 300,
                },
              ]}
              content={ner?.type}
              action={showHover ? "hover" : "xyz"}
              position="bottom"
            >
              <WorkspaceChip
                key={`${chunk_id}_ner_${i}`}
                label={`${mapNERWithIcon(ner?.type)} ${ner?.value}`}
              />
            </Popable>
          );
        })}
      {ners && ners?.length > maxNerByChunk && (
        <TouchableOpacity
          onPress={() => setIsExpanded(!isExpanded)}
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginLeft: 5,
            paddingVertical: 2,
            paddingHorizontal: 4,
          }}
        >
          <AppIcon
            name={isExpanded ? "chevron-up" : "chevron-down"}
            size={16}
            color={currentTheme?.theme?.primary}
          />
          <AppText
            style={{
              fontSize: currentTheme?.theme?.extra_small_font_size,
              marginLeft: 4,
              fontWeight: "bold",
              color: currentTheme?.theme?.primary,
            }}
            preventTranslation
            isHoverable
          >
            {isExpanded
              ? "Show less"
              : `+${ners?.length - maxNerByChunk} - Show more`}
          </AppText>
        </TouchableOpacity>
      )}
    </View>
  );
};

export default NerViewComponent;
